import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { mapActions } from "vuex";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "community-list",
  data: function data() {
    return {
      searchForm: {
        page: 1,
        limit: 20,
        title: "",
        status: "",
        tag: "",
        name: "",
        phone: "",
        city_name: "",
        categories: [],
        flow_pool: "",
        content: "",
        tag_names: []
      },
      pageDB: null,
      tagList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      categoryList: [],
      //类别
      trafficPools: [{
        name: "限制",
        value: 1
      }, {
        name: "普通",
        value: 2
      }, {
        name: "优质",
        value: 3
      }, {
        name: "极佳",
        value: 4
      }, {
        name: "官方精选",
        value: 5
      }],
      //流量池列表
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var data, filterKeys;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.databasePage({
              user: true
            });
          case 1:
            _this.pageDB = _context.v;
            _context.n = 2;
            return _this.pageDB.value();
          case 2:
            data = _context.v;
            if (data.searchForm) {
              filterKeys = ["status", "title", "name", "phone", "city_name", "categories", "flow_pool", "tag_names", "content"];
              filterKeys.forEach(function (key) {
                if (data.searchForm[key] !== undefined) {
                  _this.searchForm[key] = data.searchForm[key];
                }
              });
            }
            _this.getCategoryList();
            _this.getData();
            _this.getTagList();
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  watch: {
    searchForm: {
      handler: function handler() {
        var _this2 = this;
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var filterState, filterKeys;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (_this2.pageDB) {
                  filterState = {};
                  filterKeys = ["status", "title", "name", "phone", "city_name", "categories", "tag_names", "content"];
                  filterKeys.forEach(function (key) {
                    filterState[key] = _this2.searchForm[key];
                  });
                  _this2.pageDB.set("searchForm", filterState).write();
                }
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }))();
      },
      deep: true
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/db", ["database", "get", "databasePage"])), {}, {
    getTagList: function getTagList(e) {
      var _this3 = this;
      console.log(e);
      this.$api.getCommunityTagList({
        name: e
      }).then(function (res) {
        var _res$data;
        _this3.tagList = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list) || [];
      });
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        page: 1,
        limit: 20,
        keyword: "",
        status: "",
        isRecommend: "",
        tag_names: [],
        categories: [],
        name: "",
        phone: "",
        flow_pool: "",
        content: ""
      };
      this.getData();
    },
    getCategoryList: function getCategoryList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _res$data2;
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this4.$api.getCommunityCategoryList({
                page: 1,
                limit: 100
              });
            case 1:
              res = _context3.v;
              _this4.categoryList = ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.list) || [];
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _params$categories, _params$tag_names;
        var params, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this5.searchForm.page = 1;
              }
              _this5.tableLoading = true;
              params = JSON.parse(JSON.stringify(_this5.searchForm));
              params.categories = ((_params$categories = params.categories) === null || _params$categories === void 0 ? void 0 : _params$categories.join(",")) || '';
              params.tag_names = (params === null || params === void 0 || (_params$tag_names = params.tag_names) === null || _params$tag_names === void 0 ? void 0 : _params$tag_names.join(",")) || '';
              params.audit_status = "1,2"; // 待审核
              _context4.n = 1;
              return _this5.$api.getCommunityList(params);
            case 1:
              res = _context4.v;
              res.data.list.forEach(function (item) {
                item.category_names = _toConsumableArray(new Set([].concat(_toConsumableArray((item === null || item === void 0 ? void 0 : item.text_category_names) || []), _toConsumableArray((item === null || item === void 0 ? void 0 : item.admin_category_names) || []), _toConsumableArray((item === null || item === void 0 ? void 0 : item.media_category_names) || []))));
              });
              _this5.tableData = res.data.list;
              _this5.total = res.data.count;
              _this5.tableLoading = false;
              _this5.getUserListByIds(_this5.tableData, "user_id");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // 开放|关闭
    operation: function operation(row) {
      var _this6 = this;
      this.$confirm("确认操作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this6.$api.updateCommunity(_objectSpread(_objectSpread({}, row), {}, {
                status: row.status == 2 ? 1 : 2
              }));
            case 1:
              _this6.$message.success(row.status == 2 ? "已关闭" : "已开放");
              _this6.getData();

              // 操作上报
              _this6.$operationLog.push({
                code: row.status == 2 ? "close" : "open",
                userId: row.user_id,
                operationType: "community",
                detailBatchNo: row.id
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))).catch(function () {});
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/community/update",
        query: {
          id: row.id,
          userId: row.user.id,
          from: "community_list_edit"
        }
      });
    },
    deleteItem: function deleteItem(row) {
      var _this7 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this7.$api.delCommunity(row.id);
            case 1:
              _this7.$message.success("操作成功");
              _this7.getData();

              // 操作上报
              _this7.$operationLog.push({
                code: "delete",
                userId: row.user_id,
                operationType: "community",
                detailBatchNo: row.id
              });
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))).catch(function () {});
    },
    comment: function comment(row) {
      this.$router.push({
        path: "/community/comment",
        query: {
          id: row.id
        }
      });
    }
  })
};